import { Chip } from '@mui/material'
import { t } from 'i18next'

import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'

const lifecycleStatuses = {
  active: {
    color: 'success',
    label: 'devices.lifecycle.active'
  },
  disabled: {
    color: 'warning',
    label: 'devices.lifecycle.disabled'
  },
  deleted: {
    color: 'default',
    label: 'devices.lifecycle.deleted'
  }
}

const LifecycleBadge = ({ status }) => {
  const { currentUser: { isSuperAdmin } } = useAuth()

  if (!isSuperAdmin) return null

  const lifecycleStatus = lifecycleStatuses[status]

  if (!lifecycleStatus) return null

  return (
    <Chip
      size="small"
      variant="outlined"
      color={lifecycleStatus.color}
      label={t(lifecycleStatus.label)}
    />
  )
}

export default LifecycleBadge